<!-- 财务流水，暂未使用 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">客户</div>
                <el-autocomplete
                    class="search-item"
                    clearable
                    v-model.trim="searchData.CName"
                    :fetch-suggestions="querySearch"
                    placeholder="客户名称"
                    size="small"
                ></el-autocomplete>
                <div class="search-name">单据号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" placeholder="销售单号"></el-input>
                <div class="search-name">单据类型</div>
                <el-select class="search-item" size="small" v-model="searchData.PRType">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">支付方式</div>
                <el-select class="search-item" size="small" v-model="searchData.PayType">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">创建日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" border="" :data="tableData" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column width="120px" prop="PRTypeName" label="单据类型" show-overflow-tooltip></el-table-column>
                <el-table-column width="180px" prop="OrderCode" label="单据号码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="CName" label="客户/供应商" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="PayTypeName" label="支付方式" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SumPayable" label="单据总额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ShipMoney" label="运费" show-overflow-tooltip></el-table-column>
                <el-table-column label="合计" show-overflow-tooltip>
                    <template slot-scope="scope">{{ (scope.row.SumPayable + scope.row.ShipMoney).toFixed(2) }}</template>
                </el-table-column>
                <el-table-column prop="AlreadyPaid" label="已付/收金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="NowPay" label="现付/收金额" show-overflow-tooltip></el-table-column>
                <el-table-column label="余额" show-overflow-tooltip>
                    <template slot-scope="scope">{{ (scope.row.SumPayable + scope.row.ShipMoney - scope.row.AlreadyPaid - scope.row.NowPay).toFixed(2) }}</template>
                </el-table-column>
                <el-table-column width="80px" prop="Operator" label="操作人" show-overflow-tooltip></el-table-column>
                <el-table-column width="160px" prop="CreateTime" label="支付时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="flow"></statistics>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb
    },
    props: ['type'],
    data() {
        return {
            timeVisible: false,
            statisticsVisible: false,
            multipleSelection: [],
            searchData: {
                PayType: '',
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                CName: '',
                OrderCode: '',
                PRType: '-1',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '-1' },
                { Text: '销售收款', Value: '0' },
                { Text: '采购退货收款', Value: '1' },
                { Text: '采购付款', Value: '2' },
                { Text: '销售退货付款', Value: '3' }
            ],
            payWayList: []
        };
    },
    mounted() {
        this.getTableData();
        this.getPay();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('salesOrder');
    },
    watch: {
        NeedRefresh(value) {
            if (value.NeedRefresh) {
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$route.query;
        }
    },
    methods: {
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },

        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转编辑
        add(type, item) {
            let id = item ? item.EntpCusOId : '';
            if (this.type == 'warehouse') {
                this.$router.push(`/inventoryManage/salesOrder/takeOut/edit?type=${type}&id=${id}&fromLv2=goods`);
            } else {
                this.$router.push(`/financeManage/salesOrder/gathering/edit?type=${type}&id=${id}&fromLv2=revenue`);
            }
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.searchData.EntpId,
                PayType: '',
                CName: '',
                OrderCode: '',
                PRType: '-1',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetPaymentAndReceiptRecordsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        querySearch(queryString, cb) {
            this.$util.searchCustomerAndSupplier(queryString).then(data => {
                let customerList = [];
                for (let i in data) {
                    customerList.push({
                        value: data[i].EntpCusName
                    });
                }
                cb(customerList);
            });
        }
    }
};
</script>
